import TranslationFetch, { ResetLanguage } from './translation-fetch-action';

export default {
    TranslationFetch,
    ResetLanguage,
};
